"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const TENANTS = {
  demo: 'demo',
  chile: 'chile',
  germany: 'germany',
  greece: 'greece',
  ireland: 'ireland',
  peru: 'peru',
  southAfrica: 'southAfrica'
};
const FLOWS = {
  handset: 'handset',
  plan: 'plan',
  allflows: 'allflows',
  handsetMixed: 'handsetMixed',
  handsetMixedA: 'handsetMixedA',
  handsetMixedB: 'handsetMixedB',
  planMixed: 'planMixed',
  planFixed: 'planFixed',
  marketplace: 'marketplace',
  broadband: 'broadband',
  ireland: 'ireland',
  maac_ie: 'maac_ie',
  businessSolutions: 'businessSolutions'
};

// Define tenant based on environment or default to 'allflows'
const tenant = process.env.REACT_APP_TENANT || TENANTS.demo;

// Define the config file name, considering tenant and environment
const journeyName = process && process.env.NODE_ENV !== 'test' && process.env.REACT_APP_JOURNEY || FLOWS.allflows;

// Dynamically require the correct config file based on tenant and configName
var _default = require(`./${tenant}/config.${journeyName}.json`);
exports.default = _default;